import React from 'react'
import Slider from 'react-slick'

import slide_default from '../img/reviews/index.png'

import slide2 from '../img/reviews/engr_psah.png'


export default class SimpleSlider extends React.Component {

  render() {

    var settings = {
      dots: true,
      infinite: false,
      draggable: false,
      speed: 500,
      slidesToScroll: 1,
      centerMode: true,
      responsive: [ { breakpoint: 992, settings: { slidesToShow: 1, centerMode: false, draggable: true, adaptiveHeight: true } }, { breakpoint: 100000, settings: { slidesToShow: 3 } } ]
    }
    return (
      <Slider {...settings}>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide2} alt="Engr. PSAH"/>
              </div>
              <div className="slider-item-name">Engr. PSAH</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href="https://www.trustpilot.com/reviews/5aba01a96d33bc08ec85accd" target="_blank">TrustPilot</a></div>
              <div className="slider-item-title">Overall i am satisfied with the work…</div>
              <div className="slider-item-text">Overall i am satisfied with the work load in this season and the diversity of the orders helped me to increase my analytical and researcher skills.</div>
            </div>

        </div>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Writer&apos;s ID #28612*"/>
              </div>
              <div className="slider-item-name">Writer&apos;s ID #28612*</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href={`${process.env.GATSBY_API_URL}/reviews.html#28612*`}>UvoCorp</a></div>
              <div className="slider-item-title">It&apos;s very beneficial to work with you!</div>
              <div className="slider-item-text">Although more legal orders would be nice to have, in general Uvo corp is a must for both people that are beginners in remote writing! It also accommodates experienced writers very well. You are very consistent with everything written in the FAQs...</div>
            </div>

        </div>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Stephen Mwaniki"/>
              </div>
              <div className="slider-item-name">Stephen Mwaniki</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href="https://www.trustpilot.com/reviews/5a8fa31bd27b0a0594d03241" target="_blank">TrustPilot</a></div>
              <div className="slider-item-title">Always the Best</div>
              <div className="slider-item-text">UvoCorp is one of the best companies that i have worked for. I have been a freelancer in it for less than four months but what i have learnt over the period is more than what i can imagine. The reward per page is awesome, and it inspires me to work harder to increase my earnings... </div>
            </div>

        </div>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Writer&apos;s ID #26272*"/>
              </div>
              <div className="slider-item-name">Writer&apos;s ID #26272*</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href={`${process.env.GATSBY_API_URL}/reviews.html#26272*`}>UvoCorp</a></div>
              <div className="slider-item-title">It is very beneficial to work with the company.</div>
              <div className="slider-item-text">There is a constant flow of orders for the most part of the year, the payment department is fast, efficient, and supports several payment methods and the support team as well as company regulations are excellent, easy to work with, and foster professionalism.</div>
            </div>

        </div>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Oduor Fredrick"/>
              </div>
              <div className="slider-item-name">Oduor Fredrick</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href="https://www.trustpilot.com/users/5a71e1790000ff000b0b4612" target="_blank">TrustPilot</a></div>
              <div className="slider-item-title">Simply the Best</div>
              <div className="slider-item-text">I have been with Uvocorp fo 9 years. It is the best freelance writing company. The selling points of the company are good pay per page and unwillingness to fine writers unless a case has been reviewed extensively. I recommend the company to any budding writer.</div>
            </div>

        </div>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Writer&apos;s ID #25570*"/>
              </div>
              <div className="slider-item-name">Writer&apos;s ID #25570*</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href={`${process.env.GATSBY_API_URL}/reviews.html#25570*`}>UvoCorp</a></div>
              <div className="slider-item-title">It is GREAT!</div>
              <div className="slider-item-text">I love working with you, I can be ill and still not discouraged because of it, I can be at a remote location, but still have an opportunity to finish assignments, which means for me advancing of my skills and flourishing of my vocabulary! I also feel that I can help those who need assistance.</div>
            </div>

        </div>
        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Stephen Mwangi"/>
              </div>
              <div className="slider-item-name">Stephen Mwangi</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href="https://www.trustpilot.com/reviews/5a6c35e66116dd0e940eb1f3" target="_blank">TrustPilot</a></div>
              <div className="slider-item-title">A Land of Opportunity</div>
              <div className="slider-item-text">A company where the writer’s effort is appreciated in all ways possible. The support is very professional and ready to assist 24/7. There are sufficient orders, which are handsomely rewarded. The site is easy to use as it is self-explanatory...</div>
            </div>

        </div>

        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Writer&apos;s ID #12810*"/>
              </div>
              <div className="slider-item-name">Writer&apos;s ID #12810*</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href={`${process.env.GATSBY_API_URL}/reviews.html#12810*`}>UvoCorp</a></div>
              <div className="slider-item-title">Excellent</div>
              <div className="slider-item-text">I find UVOCORP as a highly professional site for freelance writers. I appreciate and am grateful to be part of this company in more than three years now. I&apos;m looking forward to continuously working with you and witness all improvements and progress.</div>
            </div>

        </div>

        <div>

            <div className="slider-item">
              <div className="slider-item-avatar">
                <img src={slide_default} alt="Nisa S"/>
              </div>
              <div className="slider-item-name">Nisa S</div>
              <div className="slider-item-rating">
                <ul className="rating">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                  <li className="rating-empty"></li>
                </ul>
              </div>
              <div className="slider-item-publish">Published on <a href="https://www.trustpilot.com/reviews/5a5e6f736116dd0614de55f1" target="_blank">TrustPilot</a></div>
              <div className="slider-item-title">The company itself is professional and …</div>
              <div className="slider-item-text">The company itself is professional and provides necessary support to writers, but the nature of the work is that writing for academia takes time and the compensation is not on par with the effort and skills required for producing well-written material. But that&apos;s just what it is, I suppose - don&apos;t expect to make money you can live on by doing this.</div>
            </div>

        </div>

      </Slider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/layouts/slider.js